var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E1E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2378 12.2159C20.732 13.2426 15.1643 17.8268 12.9784 23.9561C12.2516 25.9945 11.9959 27.5779 12 30.0169C12.0055 33.2344 12.558 35.5765 13.9432 38.2536C17.9117 45.9234 26.7208 49.682 35.0978 47.2799C36.7771 46.7984 39.3654 45.4998 40.7832 44.4275C43.5822 42.3107 45.7925 39.3141 46.9845 36.0205C48.2904 32.4129 48.3393 28.1238 47.1167 24.4444C44.3303 16.0589 35.8686 10.8536 27.2378 12.2159ZM33.5258 14.0352C38.246 15.1129 42.226 18.163 44.4697 22.4219C48.6973 30.4464 45.6076 40.2669 37.5178 44.5178C31.214 47.8305 23.5095 46.6336 18.4171 41.5504C10.8629 34.0099 12.3951 21.5697 21.5627 16.011C23.4387 14.8734 25.4721 14.1385 27.7189 13.7861C28.9722 13.5895 32.1753 13.7269 33.5258 14.0352ZM32.7743 27.5605L25.8042 34.5189L23.0681 31.7903C21.5634 30.2896 20.236 29.0618 20.1184 29.0618C20.0008 29.0618 19.3913 29.5868 18.7637 30.2285L17.6229 31.3953L20.6191 34.413C25.0992 38.9255 25.6205 39.4317 25.7872 39.4317C25.9783 39.4317 42.2743 23.177 42.2743 22.9865C42.2743 22.8086 40.0575 20.6021 39.8787 20.6021C39.8049 20.6021 36.6078 23.7334 32.7743 27.5605Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkLight);
export default __webpack_public_path__ + "static/media/checkmark-light.9a8bf169cf62966ca58c50ccfdc2b6fc.svg";
export { ForwardRef as ReactComponent };